import { IonModal } from "@ionic/react";
import { useQuery } from "@apollo/client";
import { useState } from "react";

import { AppCards, Breadcrumbs } from "../../components";
import ServiceList from "./components/ServiceList";

import { GET_ALL_PACKGE_PRICE } from "../../graphql/queries/price.query";

import Risorsa from "../../assets/images/Risorsa.svg";
import Pratiche from "../../assets/images/praticha.svg";

import "../Services/Auto/auto.styles.css";
import CustomQuote from "./components/CustomQuote";

const Services = () => {
  const breadcrumbEntries = [{ title: "Richiedi un preventivo" }];

  const [services, setServices] = useState<any[]>([]);
  const [selectedService, setSelectedService] = useState<string>("");

  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  const [formPopover, setFormPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  useQuery(GET_ALL_PACKGE_PRICE, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const result = data?.getAllPackagePrice?.data;
      setServices(result);
    },
  });

  const categoryItems = () => {
    return services.filter((item: any) =>
      selectedService === "auto"
        ? item.service === "auto"
        : item.service === "administrator"
    );
  };

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      <div className="app-page-wrapper flex-center-responsive services-page">
        <AppCards
          title="Pratiche auto e trasporti"
          image={Risorsa}
          onClick={(e: any) => {
            e.persist();
            setSelectedService("auto");
            setShowPopover({ showPopover: true, event: undefined });
          }}
        />

        <AppCards
          title="Pratiche amministrative"
          image={Pratiche}
          onClick={(e: any) => {
            e.persist();
            setSelectedService("amministrative");
            setShowPopover({ showPopover: true, event: undefined });
          }}
        />
      </div>

      <IonModal
        cssClass="auto-height"
        isOpen={popoverState.showPopover}
        onDidDismiss={() =>
          setShowPopover({ showPopover: false, event: undefined })
        }
      >
        <div className="categories-inner-content">
          <ServiceList
            items={categoryItems()}
            category={selectedService}
            onCustomQuote={() => {
              setShowPopover({
                showPopover: false,
                event: undefined,
              });
              setFormPopover({
                showPopover: true,
                event: undefined,
              });
            }}
          />
        </div>
      </IonModal>

      <IonModal
        cssClass="custom-form-popover"
        isOpen={formPopover.showPopover}
        onDidDismiss={() =>
          setFormPopover({ showPopover: false, event: undefined })
        }
      >
        <CustomQuote
          onComplete={() =>
            setFormPopover({ showPopover: false, event: undefined })
          }
        />
      </IonModal>
    </div>
  );
};

export default Services;
